import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { generateEntity } from 'src/shared/entities/utils/generate-base-entity'
import { WebsiteLogoInterface } from 'src/shared/types/entities/website-logo-interface'

export const createWebsiteLogo = (
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): WebsiteLogoInterface => {
  return {
    ...generateEntity(EntityTypeEnum.WebsiteLogo, parentId, masterBlockId),
    logoFileId: null,
    logoText: 'Logo',
  }
}
